export class Cell {
  constructor(public text: string) {
  }
  public isSelected: boolean = false;
  public displayText: string = null;

  clone(): Cell {
    const cell = new Cell(this.text);
    cell.isSelected = this.isSelected;
    cell.displayText = this.displayText;
    return cell;
  }
}
